import { render } from "./TheGlobalPrivacyNotification.vue?vue&type=template&id=38f3c836&scoped=true&ts=true"
import script from "./TheGlobalPrivacyNotification.vue?vue&type=script&lang=ts"
export * from "./TheGlobalPrivacyNotification.vue?vue&type=script&lang=ts"

import "./TheGlobalPrivacyNotification.vue?vue&type=style&index=0&id=38f3c836&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38f3c836"]])

export default __exports__